import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanoAlimentarService } from '../../../services/plano-alimentar/plano-alimentar.service';
import { PlanoAlimentar } from '../../../models/PlanoAlimentar';
import { AuthService } from '../../../services/auth/auth.service';
import { PlanoStatus } from '../../../models/PlanoStatus';

@Component({
  selector: 'app-plano-alimentar-pessoa',
  imports: [
    CommonModule
  ],
  templateUrl: './plano-alimentar-pessoa.html',
  styleUrl: './plano-alimentar-pessoa.scss'
})
export class PlanoAlimentarPessoa implements OnInit, OnChanges {
  @Input() caracteristicas: any;
  @Output() planoSelecionado = new EventEmitter<PlanoAlimentar>();
  pessoaId!: number;
  usuarioNome: string = "";
  planosAlimentares: PlanoAlimentar[] = [];
  statusAtivo = PlanoStatus.ATIVO;
  statusRascunho = PlanoStatus.RASCUNHO;
  statusInativo = PlanoStatus.INATIVO;
  statusExpirado = PlanoStatus.EXPIRADO;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private planoAlimentarService: PlanoAlimentarService
  ) { }

  async ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.usuarioNome = this.authService.getClaim("nome");

    if (id) {
      this.pessoaId = +id;
      this.planosAlimentares = await this.planoAlimentarService.listarPlanosAlimentares(this.pessoaId);
      this.ordenarPlanos();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['caracteristicas'] && changes['caracteristicas'].currentValue) {
      this.adicionarPlano();
    }
  }

  adicionarPlano() {
    const novoPlano = new PlanoAlimentar;
    novoPlano.idPessoa = this.pessoaId;
    novoPlano.criador = this.usuarioNome!;
    novoPlano.caracteristicas = this.caracteristicas.caracteristicas;
    novoPlano.condicoesClinicas = this.caracteristicas.condicoesClinicasEspecificas;
    novoPlano.periodo = this.caracteristicas.periodo;
    novoPlano.status = PlanoStatus.RASCUNHO;

    this.planosAlimentares?.push(novoPlano);
    this.ordenarPlanos();
  }

  acessarPlano(plano: PlanoAlimentar) {
    this.planoSelecionado.emit(plano);
  }

  private ordenarPlanos() {
    this.planosAlimentares.sort((a, b) => {
      const dataA = new Date(a.periodo?.inicio);
      const dataB = new Date(b.periodo?.inicio);
      return dataA.getTime() - dataB.getTime();
    });
  }

  obterStatusLabel(status: PlanoStatus): string {
    switch (status) {
      case PlanoStatus.ATIVO:
        return 'Ativo';
      case PlanoStatus.RASCUNHO:
        return 'Rascunho';
      case PlanoStatus.EXPIRADO:
        return 'Expirado';
      case PlanoStatus.INATIVO:
        return 'Inativo';
      default:
        return status;
    }
  }
}
